import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "confirm-modal-overlay"
}
const _hoisted_2 = { class: "confirm-modal-dialog" }
const _hoisted_3 = { class: "confirm-modal-content" }
const _hoisted_4 = { class: "confirm-modal-body" }
const _hoisted_5 = { class: "confirm-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", null, _toDisplayString(_ctx.message), 1),
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.prompt), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirm(true))),
                class: _normalizeClass(['confirm-modal-btn', _ctx.confirmType])
              }, _toDisplayString(_ctx.confirmText), 3),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirm(false))),
                class: _normalizeClass(['confirm-modal-btn', _ctx.cancelType])
              }, _toDisplayString(_ctx.cancelText), 3)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}